<div class="eventq-detection-overlay" [class.eventq-detection-overlay--clickable]="clickable()">
  @for (box of stageBoxes(); track box.trackId ?? box.id ?? box.eventType + box.offsetSeconds) {
    <eventq-detection-bounding-box
      [eventType]="box.eventType"
      [x]="box.x"
      [y]="box.y"
      [width]="box.width"
      [height]="box.height"
      [clickable]="clickable()"
      [animated]="animated()"
      (activated)="onBoxClick(box, $event)"
    />
  }
</div>
